import React from 'react'
import { useTranslation } from 'react-i18next'
import { Highlight, Icon } from '@node-space/ui-components'
import { EmbeddedCustomerStatuses, EmbeddedCustomerTypes } from '../helpers/constants'
import {
  EmbeddedCustomerAgreementStatus,
  EmbeddedCustomerStatus,
  EmbeddedCustomerType,
} from '../helpers/types'
import { getAgreementStatusHighlight } from '../helpers/utils'

export interface CustomerTypeHighlightProps {
  type: EmbeddedCustomerType
}
export const CustomerTypeHighlight = ({ type }: CustomerTypeHighlightProps) => {
  const { t } = useTranslation()
  const typeLabel = t(`embeddedCustomers.type.${type}`)
  return (
    <Highlight
      iconElement={
        <Icon
          name={type === EmbeddedCustomerTypes.BUSINESS ? 'BuildingOffice' : 'UserCircle'}
          size="small"
          aria-label={typeLabel}
        />
      }
      variant="emphasis"
      {...(type === EmbeddedCustomerTypes.INDIVIDUAL && { type: 'warning' })}
    >
      {typeLabel}
    </Highlight>
  )
}

export interface CustomerStatusHighlightProps {
  status: EmbeddedCustomerStatus
}
export const CustomerStatusHighlight = ({ status }: CustomerStatusHighlightProps) => {
  const { t } = useTranslation()
  const statusLabel = t(`embeddedCustomers.status.${status}`)
  return (
    <Highlight {...(status === EmbeddedCustomerStatuses.ACTION_REQUIRED && { type: 'warning' })}>
      {statusLabel}
    </Highlight>
  )
}

export interface CustomerAgreementStatusHighlightProps {
  status: EmbeddedCustomerAgreementStatus
}
export const CustomerAgreementStatusHighlight = ({
  status,
}: CustomerAgreementStatusHighlightProps) => {
  const { t } = useTranslation()
  const agreementStatus = getAgreementStatusHighlight(status)
  return <Highlight type={agreementStatus?.type}>{t(agreementStatus?.label)}</Highlight>
}
